import { languagePreferenceLocales } from 'localization/languages'

export const languageISO6391Mappings = languagePreferenceLocales

export type TextMap = Record<string, string>

export function getGoogleTranslateTargetLanguage(languagePreference?: string) {
  if (!languagePreference) return undefined

  return languageISO6391Mappings[languagePreference.toLowerCase()]
}

export const translateText = async <T extends TextMap>(textsObj: T, targetLang: string): Promise<T> => {
  const textArray = Object.values(textsObj) // Convert object to array of text values

  const response = await fetch(
    `https://translation.googleapis.com/language/translate/v2?key=${import.meta.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        q: textArray,
        target: targetLang,
      }),
    }
  )

  const data = await response.json()

  if (!data.data || !data.data.translations) {
    throw new Error('Invalid response from translation API')
  }

  const translatedTexts = data.data.translations.map((t: { translatedText: string }) => t.translatedText)

  // Convert back into an object, preserving the original keys
  return Object.keys(textsObj).reduce<T>((acc, key, index) => {
    acc[key as keyof T] = translatedTexts[index]
    return acc
  }, {} as T)
}
